import React, { useState, useEffect } from 'react';
import { defineBlock, smartProps, EditableHeading, EditableText } from '@smartfire/gutenberg-react';
import PTCard from '../pt-card/block';
import style from './block.module.scss';
import SearchIcon from '@material-ui/icons/Search';
import apiFetch from '@wordpress/api-fetch';

const Block = () => {
    const [search, setSearch] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        apiFetch({
            path: `/wp/v2/player?_embed=1&orderby=title&order=asc&per_page=-1&search=${search}`,
            method: 'GET',
        })
            .then((res) => {
                setPlayers(res);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [search]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSearch(searchValue);
    };

    return (
        <div className={style.block}>
            <div className={style.container}>
                <div className={style.title}>
                    <EditableHeading smartProp="title" />
                </div>
                <EditableText smartProp="description" placeholder="Description" className={style.description} />
                <form onSubmit={handleSubmit}>
                    <div className={style.formWrap}>
                        <div className={style.input}>
                            <input
                                type="text"
                                value={searchValue}
                                placeholder="Rechercher"
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <SearchIcon />
                        </div>
                        <button type="submit" className={style.btn}>
                            Rechercher
                        </button>
                    </div>
                </form>
                <div className={style.list}>
                    {players &&
                        players.map((team) => (
                            <PTCard
                                url={
                                    team._embedded &&
                                    team._embedded['wp:featuredmedia'] &&
                                    team._embedded['wp:featuredmedia'][0] &&
                                    team._embedded['wp:featuredmedia'][0].source_url
                                }
                                title={team.title.rendered}
                                position={team.acf.position}
                                from={team.acf.from}
                                key={team.id}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 1,
            content: 'Les joueurs',
        }),
        description: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'PT Liste',
    },
});
